import { Component, Input } from '@angular/core';
import { KeysetPagingPagerButtonsComponent } from './keyset-paging-pager-buttons/keyset-paging-pager-buttons.component';
import { KeysetPagingStore } from './keyset-paging-store';

export {
  KeysetPagingStore,
  KeysetPagingStoreOptions,
  KeysetPagingKeyedSortContextOptions,
  KeysetGridServiceRow,
  KeysetListGridBindResult
} from './keyset-paging-store';

@Component({
  selector: 'app-keyset-paging',
  standalone: true,
  imports: [KeysetPagingPagerButtonsComponent],
  template: `
    <app-keyset-paging-pager-buttons
      [loading]="loading"
      [hasPrevious]="store.session.hasPrevious"
      [hasMore]="store.session.hasMore"
      [pageSizes]="pageSizes"
      (first)="store.pagerFirst()"
      (prev)="store.pagerPrev()"
      (next)="store.pagerNext()"
      (last)="store.pagerLast()">
    </app-keyset-paging-pager-buttons>
  `
})
export class KeysetPagingComponent
{
  @Input({ required: true }) public store!: KeysetPagingStore;
  @Input() public loading = false;
  @Input() public pageSizes: number[] | null = null;
}
